export default (theme) => {
  const {
    white,
    lightGrey,
    red,
    palePink,
    darkGrey,
  } = theme.palette.common
  const { maxContentWidth } = theme.global

  return {
    /* Primary footer */

    primaryContainer: {
      backgroundColor: palePink,
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(6),
      },
    },

    primaryContent: {
      maxWidth: maxContentWidth,
      margin: '0 auto',
      padding: theme.spacing(5, 0, 6, 0),
      display: 'flex',
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(5, 6),
      },
      [theme.breakpoints.down('xs')]: {
        padding: 0,
      },
    },

    navigationContainer: {
      marginTop: theme.spacing(4),
    },

    menuContainer: {
      marginTop: theme.spacing(2),
    },

    subMenuContainer: {
      margin: 0,
      paddingLeft: theme.spacing(3),
    },

    link: {
      color: darkGrey,
      '&:hover': {
        textDecoration: 'underline',
      },
    },

    noUnderline: {
      '&:hover': {
        textDecoration: 'none',
      },
    },

    email: {
      color: lightGrey,
      '&:hover': {
        textDecoration: 'underline',
      },
    },

    /* Secondary footer */

    secondaryContainer: {
      backgroundColor: red,
      padding: theme.spacing(4, 0),
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(2, 4),
      },
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
      },
    },

    secondaryContent: {
      maxWidth: maxContentWidth,
      margin: '0 auto',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },

    copyrightContainer: {
      flex: 3,
      color: white,
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
        marginTop: theme.spacing(2),
      },
    },

    socialContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
    },

    columnContainer: {
      [theme.breakpoints.down('xs')]: {
        '&:not(:last-child)': {
          marginBottom: theme.spacing(3),
        },
      },
    },

    social: {
      color: white,
      display: 'inline-block',
      margin: theme.spacing(0, 2),
    },

    footerSocial: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        margin: theme.spacing(2.5, 0),
        justifyContent: 'center',
      },
    },

    storeLinksContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },

    storeBadge: {
      height: '40px',
      margin: theme.spacing(0, 1),
    },
  }
}
